import { BalanceSheetNoneType } from "../types"


function getTotalBalance(
  element: BalanceSheetNoneType,
  data: Array<BalanceSheetNoneType>
): {
  actual: number
  variance: number
  percent_variance: number,
  budget: number
} {
  let totalActual = element.actual
  let totalVariance = element.variance
  let totalPercent = element.percent_variance
  let totalBudget = element.budget  

  const children = data.filter((coa) => coa.parent_id === element.coa_id)

  children.forEach((child) => {
    const childTotals = getTotalBalance(child, data)

    totalActual += childTotals.actual
    totalVariance += childTotals.variance
    totalPercent += childTotals.percent_variance
    totalBudget += childTotals.budget
  })

  return {
    actual: totalActual,
    variance: totalVariance,
    percent_variance: totalPercent,
    budget: totalBudget
  }
}


export const calculateParent = (data: Array<BalanceSheetNoneType>) => {
  return data?.map((element) => {
    const children = data.filter((coa) => coa.parent_id === element.coa_id)

    if (!children.length) return element

    const totals = getTotalBalance(element, data)

    return { 
      ...element, 
      actual: totals.actual,
      variance: totals.variance,
      budget: totals.budget,
      percent_variance: totals.percent_variance  
    }
  })
}
